import script from "./HeaderChatMessagesPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderChatMessagesPanel.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderChatMessagesPanel.vue?vue&type=style&index=0&id=363d6690&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-363d6690"]])

export default __exports__